import messageLikes from './message-like';
import messageUnlikes from './message-unlike';

const fn = {
  init: () => {
    messageLikes.init();
    messageUnlikes.init();
  },
};

export default fn;
